export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-en-c02374e2b1ac782df75edcfe1b147142.webp";